import React, { useState } from 'react'

import * as S from './styles'

import IProps from './props'

const TextArea = ({ label, ...textAreaProps }: IProps) => {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <S.Container active={isFocused}>
      <S.Label>{label}</S.Label>
      <S.TextArea
        {...textAreaProps}
        maxLength={textAreaProps.maxLength || 1000}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <S.Counter>
        {`${textAreaProps.value?.toString().length}/${
          textAreaProps.maxLength
        }`}
      </S.Counter>
    </S.Container>
  )
}
export default TextArea
